module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_ES-130cc1b9597658191c530a7639a0e1a7.svg";